import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot, $isElementNode } from "lexical";
import { $isVariableNode, VariableNode } from "./variable-node";

/** Updates variable values in place when populate data changes (no re-seed). */
export function VariableValuesPlugin(_ref) {
  var values = _ref.values;
  var _useLexicalComposerCo = useLexicalComposerContext(),
    _useLexicalComposerCo2 = _slicedToArray(_useLexicalComposerCo, 1),
    editor = _useLexicalComposerCo2[0];
  useEffect(function () {
    if (!editor.hasNodes([VariableNode])) return;
    editor.update(function () {
      var _visit = function visit(node) {
        if ($isVariableNode(node)) {
          var next = values[node.getLabel()] || undefined;
          if (node.getValue() !== next) node.setValue(next);
        }
        if ($isElementNode(node)) node.getChildren().forEach(_visit);
      };
      $getRoot().getChildren().forEach(_visit);
    });
  }, [editor, values]);
  return null;
}